export default function GetProductTypeEnum(){
  return productType;
}

const productType = {
  FullUW : 1,
  SPWL : 2,
  AmericoLoanProtector: 5
};
Object.freeze(productType);